import { useEffect } from 'react'
import useGetOrganization from './useGetOrganization'

export default function useOrganization(organizationId?: number) {
  const [getOrganization, { result, loading, called, error }] = useGetOrganization()

  useEffect(() => {
    if (organizationId) {
      getOrganization(organizationId)
    }
  }, [getOrganization, organizationId])

  return {
    result,
    loading: loading || !called,
    error,
    called,
  }
}
